import React from 'react'
import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Login from '../Components/Auth/Login';
import PublicRouters from './PublicRouter';
import PrivateRouters from './PrivateRouter';
import { getCookie } from '../Helpers/Utils';
import Dashboard from '../Components/Dashboard';
import Category from '../Components/Category';
import ProductsList from '../Components/MyProducts/List';
// import ChooseVeritical from '../Components/ChooseVeritical';
import ProductsAdd from '../Components/MyProducts/Add';
import ProductEdit from '../Components/MyProducts/Edit';
// import Orders from '../Components/Orders'
import QRList from '../Components/QrCodes/List';
import Customers from '../Components/Customers'
import AuthenticateProvider from '../Context/AuthenticateProvider';
import ListOrders from '../Components/Orders/Order';

const index = () => {
  const person = getCookie('person')
  return (
    <React.Fragment>
      <AuthenticateProvider>
        <Router>
          <Routes>
            <Route element={<PublicRouters />}>
              <Route path="/login" element={<Login />} />
              <Route path='/*' element={<Navigate to="/login" />} />
            </Route>
            <Route element={<PrivateRouters />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/category" element={<Category />} />
              <Route path="/products" element={<ProductsList />} />
              <Route path="/products/add" element={<ProductsAdd />} />
              <Route path="/products/:id" element={<ProductEdit />} />
              <Route path="/orders" element={<ListOrders />} />
              <Route path="/qrcodes" element={<QRList />} />
              <Route path="/customers" element={<Customers />} />
            </Route>
          </Routes>
        </Router>
      </AuthenticateProvider>
    </React.Fragment>
  )
}

export default index
